module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key
  }), _vm._v(" "), (_vm.$route.meta.toBack) ? _c('float-icon', {
    staticClass: "icons-warp",
    attrs: {
      "padding": "10 10 30 10"
    }
  }, [_c('div', {
    staticClass: "to-home",
    on: {
      "click": _vm.toBack
    }
  }, [_vm._v("返回")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8230ac8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 368
// module chunks = 75